<template>
  <el-form ref="form" :model="form" label-width="120px">
    <!-- 投放机型 -->
    <el-form-item label="投放机型">
      <el-input v-model="form.brand" disabled value="vivo"></el-input>
    </el-form-item>
    <el-form-item label="cookie">
      <el-input v-model="form.cookie" ></el-input>
    </el-form-item>

    <!-- 落地页类型 -->
    <el-form-item label="落地页类型">
      <el-select v-model="form.pageType">
        <el-option label="DP" value="DP"></el-option>
        <el-option label="H5" value="H5"></el-option>
      </el-select>
    </el-form-item>

    <!-- 归属渠道 -->
    <el-form-item label="归属渠道">
      <el-select
        v-model="form.clientId"
        @change="handleChannelChange"
        :loading="loading"
        filterable
        clearable
        placeholder="请选择渠道"
      >
        <el-option
          v-for="channel in channelOptions"
          :key="channel.clientId"
          :label="channel.label"
          :value="channel.clientId"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 转换模板 -->
    <el-form-item
      v-if="showConvertTemplateSelect && convertTemplateOptions.length > 0"
      label="转换模板"
    >
      <el-select
        v-model="form.convertTemplateId"
        placeholder="请选择转换模板"
      >
        <el-option
          v-for="template in convertTemplateOptions"
          :key="template.value"
          :label="template.label"
          :value="template.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 填充方式 -->
    <el-form-item label="填充方式">
      <el-radio-group v-model="fillMode" @change="onFillModeChange">
        <el-radio label="select">下拉选择账户</el-radio>
<!--        <el-radio label="name">手动输入账户名</el-radio>-->
        <el-radio label="id">手动输入账户UUID</el-radio>
      </el-radio-group>
    </el-form-item>

    <!-- 无账户数据提示 -->
    <el-form-item v-if="authFetched && authList.length === 0" label=" ">
      <div class="empty-account-tip">
        <i class="el-icon-warning-outline"></i>
        <span>暂无可用账户，请联系客户配置</span>
      </div>
    </el-form-item>

    <!-- 下拉选择账户（模式1） -->
    <el-form-item v-if="fillMode === 'select' && authList.length > 0" label="选择账户">
      <el-select
        v-model="selectedAccounts"
        multiple
        filterable
        clearable
        placeholder="请选择账户"
        @change="onAccountSelect"
        class="account-select"
      >
        <el-option
          v-for="item in authList"
          :key="item.id"
          :label="item.name + ' （' + item.id + '）'"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 广告主（手动输入模式） -->
    <el-form-item v-if="fillMode !== 'select'" label="广告主">
      <el-input
        type="textarea"
        :rows="4"
        v-model="form.advertiserText"
        :placeholder="fillMode === 'name' ? '每行一个账户名' : '每行一个账户UUID'"
      ></el-input>
    </el-form-item>

    <!-- 下拉选择模式的结果展示 -->
    <el-form-item v-if="fillMode === 'select' && selectedAccounts.length > 0" label="已选账户">
      <div class="selected-accounts-box">
        <el-tag
          v-for="item in selectedAccountTags"
          :key="item.id"
          type="success"
          class="account-tag"
        >
          {{ item.label }}
        </el-tag>
      </div>
    </el-form-item>
    <el-form-item label="备注">
      <el-input v-model="form.memo" ></el-input>
    </el-form-item>
    <!-- 投放子平台 -->
    <el-form-item label="投放子平台">
      <el-radio-group v-model="form.subPlatform">
        <el-radio label="站内"></el-radio>
        <el-radio label="联盟"></el-radio>
      </el-radio-group>
    </el-form-item>

    <!-- 事件源类型 -->
    <el-form-item label="事件源类型">
      <el-radio-group v-model="form.srcType">
        <el-radio label="Web">网址</el-radio>
        <el-radio label="Quickapp" disabled>快应用</el-radio>
      </el-radio-group>
    </el-form-item>

    <!-- 回传事件类型 -->
    <el-form-item label="回传事件类型">
      <el-select v-model="form.eventType">
        <el-option label="加桌" :value="10"></el-option>
        <el-option label="激活" :value="0"></el-option>
      </el-select>
    </el-form-item>

    <!-- 素材落地页 -->
    <el-form-item label="素材落地页">
      <el-select v-model="form.specialPage">
        <el-option label="  " :value="0"></el-option>
        <el-option label="工具-小说" :value="10"></el-option>
        <el-option label="短剧页面" :value="12"></el-option>
        <el-option label="朔文漫卷" :value="1360"></el-option>
        <el-option label="星衍壁纸" :value="1361"></el-option>
        <el-option label="工具-手机清理" :value="1408"></el-option>
        <el-option label="壁纸大全" :value="1409"></el-option>
        <el-option label="运动计步" :value="1410"></el-option>
        <el-option label="字体大小" :value="1411"></el-option>
        <el-option label="工具-天气预报" :value="1413"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </el-form-item>

    <!-- UUID自动验证结果 -->
    <el-form-item v-if="validationResult.show" label="校验结果">
      <div class="validation-box">
        <div class="validation-summary-row">
          <span class="valid-count">有效 {{ validationResult.validCount }} 个</span>
          <span class="divider">|</span>
          <span class="invalid-count">无效 {{ validationResult.invalidCount }} 个</span>
          <span v-if="authLoading" class="checking-text">校验中...</span>
        </div>
        <div class="validation-tag-list">
          <el-tag
            v-for="item in validationResult.tagList"
            :key="item.uuid"
            :type="item.valid ? 'success' : 'danger'"
            size="small"
            class="validation-tag"
          >
            {{ item.uuid }}
          </el-tag>
        </div>
      </div>
    </el-form-item>
  </el-form>
</template>


<script>
import axios from "axios";
import XLSX from "xlsx";
export default {
  data() {
    return {
      form: {
        brand: 'vivo',
        pageType: 'DP',
        clientId: '',
        packageName: '',
        parentId: '',
        advertiserText: '',
        subPlatform: '站内',
        srcType: 'Web',
        eventType: 10,
        specialPage: 0,
        cookie:'',
        resultList:[],
        convertTemplateId: ''

      },
      businessList: [],
      channelOptions: [],
      convertTemplateOptions: [],
      showConvertTemplateSelect: false,
      loading: false,
      authFetched: false,
      authLoading: false,
      validateTimer: null,
      authList: [],
      fillMode: 'name',
      selectedAccounts: [],
      validationResult: {
        show: false,
        validCount: 0,
        invalidCount: 0,
        tagList: []
      },
      validUuidSet: []
    }
  },
  computed: {
    selectedAccountTags: function() {
      var self = this
      return this.selectedAccounts.map(function(id) {
        var account = self.authList.find(function(item) { return item.id === id })
        return {
          id: id,
          label: account ? account.name + ' （' + id + '）' : id
        }
      })
    }
  },
  created() {

  },
  watch: {
    'form.cookie': function(newVal) {
      if (newVal && this.form.pageType) {
        this.fetchBusinessList()
      }
    },
    'form.pageType': function(newVal) {
      if (newVal && this.form.cookie) {
        this.fetchBusinessList()
      }
    },
    'form.parentId': function(newVal) {
      // 选择渠道后自动获取auths数据
      if (newVal && this.form.cookie) {
        this.authFetched = false
        this.fetchAuthList()
      } else {
        this.authFetched = false
        this.authList = []
        this.validUuidSet = []
        this.clearValidation()
      }
    },
    'form.advertiserText': function() {
      // 仅手动输入模式下防抖自动验证
      if (this.fillMode !== 'select') {
        this.debounceValidate()
      }
    }
  },
  methods: {
    async fetchBusinessList() {
      // 验证必要参数
      if (!this.form.cookie || !this.form.pageType) {
        this.$message.warning('请先填写cookie和选择落地页类型')
        return
      }

      try {
        this.loading = true
        const data = {
          cookie: this.form.cookie,
          brand: 'vivo',
          pageType: this.form.pageType || 'DP'
        }
        const response = await this.$axios.post('https://control.zjwec.cn/api/vivo/group/businesss', data)

        // 响应数据直接是 businessList 数组
        let businessList = response.data
        // 兼容处理：如果 response.data 不是数组，尝试其他格式
        if (!Array.isArray(businessList)) {
          businessList = response.data.businessList || []
        }
        this.businessList = businessList

        // 映射为 channelOptions
        this.channelOptions = businessList.map(business => ({
          label: business.nickname,
          clientId: business.id.toString(),
          parentId: business.id.toString(),
          packageName: business.packageName,
          convertTemplateIds: business.convertTemplateIds || []
        }))

        if (this.channelOptions.length === 0) {
          this.$message.warning('暂无渠道数据')
        }
      } catch (error) {
        console.error('获取渠道数据失败:', error)
        this.$message.error('获取渠道数据失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },
    // 精简版（推荐）
    handleChannelChange(clientId) {
      const selected = this.channelOptions.find(item => item.clientId === clientId)
      if (selected) {
        this.form.packageName = selected.packageName
        this.form.parentId = selected.parentId

        // 处理转换模板
        if (selected.convertTemplateIds && selected.convertTemplateIds.length > 0) {
          this.convertTemplateOptions = selected.convertTemplateIds.map(id => ({
            value: id,
            label: `模板 ${id}`
          }))
          this.showConvertTemplateSelect = true
          // 默认选择第一个
          this.form.convertTemplateId = this.convertTemplateOptions[0].value
        } else {
          this.convertTemplateOptions = []
          this.showConvertTemplateSelect = false
          this.form.convertTemplateId = ''
        }
      }
    },
    async fetchAuthList() {
      if (!this.form.cookie || !this.form.parentId) {
        return
      }
      try {
        this.authLoading = true
        const response = await this.$axios.post('https://control.zjwec.cn/api/vivo/business/auths', {
          cookie: this.form.cookie,
          parentId: this.form.parentId,
          brand: 'vivo'
        })

        var authUserMap = (response.data && response.data.authUserMap) || {}
        this.authList = authUserMap[this.form.parentId] || []
        this.authFetched = true

        // 提取所有有效ID和name用于校验
        this.validUuidSet = this.authList.map(function(item) { return item.id })

        // 清空之前的选中
        this.selectedAccounts = []
        // 数据拉取成功后立即校验当前已输入的UUID
        this.doValidate()
      } catch (error) {
        console.error('获取auths数据失败:', error)
        this.$message.error('获取UUID校验数据失败: ' + error.message)
        this.authFetched = true
        this.authList = []
        this.validUuidSet = []
        this.clearValidation()
      } finally {
        this.authLoading = false
      }
    },
    onFillModeChange() {
      // 切换填充方式时，清空所有输入
      this.selectedAccounts = []
      this.form.advertiserText = ''
      this.clearValidation()
    },
    onAccountSelect(selectedIds) {
      // 下拉选择模式下，同步填充UUID到广告主文本框（用于提交）
      this.form.advertiserText = selectedIds.join('\n')
    },
    debounceValidate() {
      // 清除上次定时器，500ms防抖
      if (this.validateTimer) {
        clearTimeout(this.validateTimer)
      }
      this.validateTimer = setTimeout(this.doValidate.bind(this), 500)
    },
    doValidate() {
      var inputValues = this.form.advertiserText
        .split('\n')
        .filter(function(item) { return item.trim() })
        .map(function(item) { return item.trim() })

      if (inputValues.length === 0) {
        this.clearValidation()
        return
      }

      // 如果没有拉取过auths数据，先隐藏结果
      if (this.authList.length === 0) {
        this.clearValidation()
        return
      }

      var self = this
      var tagList = []
      var invalidCount = 0
      // 按填充方式构建有效值集合
      var validSet = this.authList.map(function(item) {
        return self.fillMode === 'name' ? item.name : item.id
      })

      inputValues.forEach(function(value) {
        var valid = validSet.indexOf(value) !== -1
        tagList.push({ uuid: value, valid: valid })
        if (!valid) {
          invalidCount++
        }
      })

      this.validationResult = {
        show: true,
        validCount: inputValues.length - invalidCount,
        invalidCount: invalidCount,
        tagList: tagList
      }
    },
    clearValidation() {
      this.validationResult = {
        show: false,
        validCount: 0,
        invalidCount: 0,
        tagList: []
      }
    },
    async submitForm() {
      // 提交前按当前输入重新校验一次，存在无效账户直接拦截
      if (this.authLoading) {
        this.$message.warning('账户数据校验中，请稍候再提交')
        return
      }
      this.doValidate()
      if (this.validationResult.invalidCount > 0) {
        this.$message.error(`存在 ${this.validationResult.invalidCount} 个无效账户，请修正后再提交`)
        return
      }

      const advertiserIds = this.form.advertiserText
        .split('\n')
        .filter(item => item.trim());

      // 存储所有请求结果
      const  self = this
      const results = [];
      self.resultList = []
      try {
        for (const [index, uuid] of advertiserIds.entries()) {
          console.log(`正在发送第 ${index + 1}/${advertiserIds.length} 个请求`);

          const  data = {
            cookie: this.form.cookie,
            memo: this.form.memo || "",
            pageType: this.form.pageType,
            brand: this.form.brand,
            subPlatform: this.form.subPlatform,
            clientId: this.form.clientId,
            eventType: this.form.eventType,
            uuid: uuid.trim(), // 使用当前广告主ID
            srcType: this.form.srcType,
            parentId: this.form.parentId,
            packageName: this.form.packageName,

          }
          if ( this.form.specialPage !==0){
            data.specialPage = this.form.specialPage
          }
          if (this.form.convertTemplateId) {
            data.convertTemplateId = this.form.convertTemplateId
          }


          const response = await this.$axios.post('https://control.zjwec.cn/api/vivo/qdxcj', data);

          console.log(response.data.list[0]);
          self.resultList.push(
            response.data.list[0]
          );

          console.log(`ID ${uuid} 请求成功`);
        }

        console.log('所有请求已完成', self.resultList);
        this.exportToExcel()
        this.$message.success('所有操作已完成');
      } catch (error) {
        console.error('请求失败:', error);
        this.$message.error(`请求失败: ${error.message}`);

        this.exportToExcel()
        // 返回已完成的请求结果
        return results;
      }
    },
    // 生成时间戳文件名
    generateFileName() {
      const now = new Date()
      const pad = n => n.toString().padStart(2, '0')
      return `${now.getFullYear()}${pad(now.getMonth()+1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.xlsx`
    },

    // 导出主方法
    exportToExcel() {
      const s = this
      try {
        // 1. 准备数据
        const headers = [
          '广告账号名称',
          '广告账号ID',

          '推广名称',
          'DP链接',
          'H5链接',
          '曝光监测',
          '点击监测',

          '建议出价'
        ]

        const data = s.resultList.map(item => [
          item.advertiser_name || '',
          item.advertiser_id || '',

          item.nickname || '',
          item.copyUrl || '',
          item.selfUrl || '',
          item.impreUrl	 || '',
          item.callBackUrl || '',

          item.suggestBid	 || '',
        ])

        // 2. 创建工作簿
        const workbook = XLSX.utils.book_new()
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data])

        // 3. 设置列宽（可选）
        worksheet['!cols'] = [
          { wch: 15 }, // 广告账号ID
          { wch: 20 }, // 广告账号名称
          { wch: 20 }, // 推广名称
          { wch: 40 }, // DP链接
          { wch: 40 }, // H5链接
          { wch: 40 }, // H5链接
          { wch: 40 }, // H5链接
          { wch: 40 }  // 点击监测
        ]

        // 4. 添加工作表
        XLSX.utils.book_append_sheet(workbook, worksheet, '推广数据')

        // 5. 生成文件并保存
        const wbout = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        })

        const blob = new Blob([wbout], { type: 'application/octet-stream' })
        saveAs(blob, this.generateFileName())

        this.$message.success('导出成功')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败: ' + error.message)
      }
    }

  }
}
</script>

<style scoped>
/* ===== 表单整体美化 ===== */
.el-form {
  max-width: 720px;
  margin: 40px auto;
  padding: 20px 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.el-form-item__label {
  font-weight: 600;
  color: #303133;
}

/* ===== 填充方式单选组 ===== */
.el-radio-group .el-radio {
  margin-right: 20px;
  margin-bottom: 0;
}

/* ===== 无账户提示 ===== */
.empty-account-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 6px;
  color: #e6a23c;
  font-size: 14px;
  font-weight: 500;
}

.empty-account-tip i {
  font-size: 20px;
  color: #e6a23c;
}

/* ===== 账户选择下拉 ===== */
.account-select {
  width: 100%;
}

/* ===== 已选账户展示 ===== */
.selected-accounts-box {
  padding: 10px 12px;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  min-height: 36px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.account-tag {
  margin: 0;
  font-size: 13px;
}

/* ===== 校验结果 ===== */
.validation-box {
  padding: 14px 16px;
  background: #fafbfc;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
}

.validation-summary-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 500;
}

.valid-count {
  color: #67c23a;
}

.invalid-count {
  color: #f56c6c;
}

.divider {
  color: #dcdfe6;
}

.checking-text {
  color: #909399;
  font-size: 13px;
  font-weight: normal;
}

.validation-tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.validation-tag {
  margin: 0;
  font-size: 13px;
}

/* ===== 提交按钮区域 ===== */
.el-form-item:last-of-type .el-button--primary {
  padding: 12px 32px;
  font-size: 15px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/qdxqdhcj.vue